import React, { useEffect } from 'react';
import { Formik } from 'formik';
import { Card, Spin, Icon } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import { getEvent, cleanEvent } from '../../store/actions/event';
import { permissions } from '../../store/selectors/user';
import config from './config';
import styles from '../../styles';

import Wrapper from './Wrapper';

const ModifyEvent = ({
  event,
  title,
  saveButtonTitle,
  action,
  getEvent,
  cleanEvent,
  match,
  history,
}) => {
  useEffect(() => {
    const { id } = match.params;
    getEvent(id).catch(() => history.push('/404'));
    return cleanEvent;
  }, []);

  useEffect(() => {
    if (event && event.id && !event.isWritable) {
      history.push('/403');
    }
  }, [event]);

  const onBackPress = () => history.goBack();

  const onSubmit = data => action(data).then(() => history.push('/events'));

  return (
    <Card
      title={title}
      style={styles.formContainer}
      extra={<Icon type="close" onClick={onBackPress} />}
    >
      <Spin spinning={!event}>
        <Formik
          initialValues={event}
          onSubmit={onSubmit}
          validationSchema={config.validate}
          enableReinitialize
        >
          {({ handleSubmit, validateForm, values, isValid, setFieldValue }) => (
            <Wrapper
              onBackPress={onBackPress}
              isValid={isValid}
              saveButtonTitle={saveButtonTitle}
              handleSubmit={handleSubmit}
              values={values}
              settings={config}
              validateForm={validateForm}
              setValue={setFieldValue}
            />
          )}
        </Formik>
      </Spin>
    </Card>
  );
};

ModifyEvent.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.number,
    game: PropTypes.arrayOf(PropTypes.string),
    isWritable: PropTypes.bool,
  }),
  getEvent: PropTypes.func.isRequired,
  cleanEvent: PropTypes.func.isRequired,
  action: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  saveButtonTitle: PropTypes.string.isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({}).isRequired,
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired,
  }).isRequired,
};

ModifyEvent.defaultProps = {
  event: null,
};

const mapStateToProps = state => {
  return {
    permissions: permissions(state),
  };
};

export default connect(mapStateToProps, { getEvent, cleanEvent })(
  withRouter(ModifyEvent),
);
